import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, httpRequestsOnLoadActions } from 'store';
import { claimPaymentService } from './claimPayment.service';
import {
    GET_CLAIM_PAYMENTS,
    GET_CLAIM_PAYMENTS_SUCCESS,
    APPEAL_CLAIM_PAYMENT,
    PAY_IN_FULL_CLAIM,
    PAY_IN_FULL_CLAIM_BILLING,
    EDIT_CLAIM_PAYMENT_INFO,
    CREATE_REMITTANCE,
    GET_REMITTANCE,
    GET_REMITTANCE_SUCCESS,
    VERIFY_REMITTANCES,
    MARK_REVIEWED_REMITTANCE,
    SYNC_TL_CLEARINGHOUSE_ERAS,
    GET_REMITTANCE_BY_ID,
    GET_REMITTANCE_BY_ID_SUCCESS,
    EDIT_REMITTANCE,
    VOID_REMITTANCE,
    MASS_VOID_REMITTANCE,
    GET_REMITTANCE_TOTAL,
    GET_REMITTANCE_TOTAL_SUCCESS,
    REMOVE_CLAIM_FROM_REMITTANCE,
    GET_REMITTANCE_BY_ID_CLAIMS,
    GET_REMITTANCE_BY_ID_CLAIMS_SUCCESS,
    GET_CLAIM_PAYMENT_FILTERED,
    GET_CLAIM_PAYMENT_FILTERED_SUCCESS,
    DELETE_REMITTANCE,
} from './claimPayment.type';
import { toast } from 'react-toastify';
import { NotError } from '../../../components';
import React from 'react';

/** Claim Payment */
function* createClaimPayments(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimPaymentService.createClaimPaymentsService, action?.payload?.data);
        const remittance = yield call(claimPaymentService.getRemittanceByIdService, res?.data?.id);
        yield put({
            type: GET_REMITTANCE_BY_ID_SUCCESS,
            payload: remittance?.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type, res?.data));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editRemittance(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        yield call(claimPaymentService.editRemittanceService, action?.payload?.id, action?.payload?.data);
        const res = yield call(claimPaymentService.getRemittanceByIdService, action?.payload?.id);
        yield put({
            type: GET_REMITTANCE_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type, res?.data?.id));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getRemittance(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimPaymentService.getRemittanceService, action?.payload?.params);
        yield put({
            type: GET_REMITTANCE_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* verifyRemittance(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));

    try {
        yield call(claimPaymentService.verifyRemittanceService, action?.payload?.ids);

        if (action?.payload?.singleId) {
            const res = yield call(claimPaymentService.getRemittanceByIdService, action?.payload?.singleId);
            yield put({
                type: GET_REMITTANCE_BY_ID_SUCCESS,
                payload: res.data,
            });
        }
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** The server starts the import in the background and answers at once with what it did. */
function* syncTlClearinghouseEras(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));

    try {
        const res = yield call(claimPaymentService.syncTlClearinghouseErasService);
        toast(<NotError type={res?.data?.started ? 'success' : 'error'} errMessage={res?.data?.message} />);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* markReviewedRemittance(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));

    try {
        yield call(claimPaymentService.markReviewedService, action?.payload?.ids, action?.payload?.reviewNote);

        if (action?.payload?.singleId) {
            const res = yield call(claimPaymentService.getRemittanceByIdService, action?.payload?.singleId);
            yield put({
                type: GET_REMITTANCE_BY_ID_SUCCESS,
                payload: res.data,
            });
        }
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getRemittanceById(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimPaymentService.getRemittanceByIdService, action?.payload?.id);
        yield put({
            type: GET_REMITTANCE_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* getRemittanceByIdClaims(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimPaymentService.getRemittanceByIdClaimsService, action?.payload?.id, action?.payload?.params);
        yield put({
            type: GET_REMITTANCE_BY_ID_CLAIMS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* voidRemittance(action) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        yield call(claimPaymentService.voidRemittanceService, action?.payload?.id, action?.payload?.params);
        const res = yield call(claimPaymentService.getRemittanceByIdService, action?.payload?.id);
        yield put({
            type: GET_REMITTANCE_BY_ID_SUCCESS,
            payload: res.data,
        });
        toast(<NotError type={'success'} errMessage={'Payment voided successfully!'} />);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* massVoidRemittance(action) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(claimPaymentService.massVoidRemittanceService, action?.payload?.data);
        const voidedCount = res?.data?.voided?.length ?? action?.payload?.data?.remittanceIds?.length ?? 0;
        const failedCount = res?.data?.failed?.length ?? 0;
        const failedList = res?.data?.failed;

        if (voidedCount) {
            toast(
                <NotError
                    type={'success'}
                    errMessage={`${voidedCount} payment${voidedCount === 1 ? ' was' : 's were'} voided successfully!`}
                />
            );
        }
        if (failedCount) {
            toast(
                <NotError
                    type={'error'}
                    errMessage={failedList?.map((i) => i?.error).join(', ') || `${failedCount} payment${failedCount === 1 ? '' : 's'} could not be voided`}
                />
            );
        }
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* deleteRemittance(action) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        yield call(claimPaymentService.deleteRemittanceService, action?.payload?.id);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getRemittanceTotal(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(claimPaymentService.getRemittanceTotalService, action?.payload?.params);
        yield put({
            type: GET_REMITTANCE_TOTAL_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getClaimPayments(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimPaymentService.getClaimPaymentsService, action?.payload?.data);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLAIM_PAYMENTS_SUCCESS,
            payload: { claimPayments: res.data },
        });
    } catch (err) {
        yield put({
            type: GET_CLAIM_PAYMENTS_SUCCESS,
            payload: { claimPayments: { claimPmt: [], count: 0 } },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}
function* getClaimPaymentFiltered(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimPaymentService.getClaimPaymentFilteredService, action?.payload?.id, action?.payload?.data);
        yield put({
            type: GET_CLAIM_PAYMENT_FILTERED_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* editClaimPaymentInfo(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimPaymentService.editClaimPmtInfoService, action?.payload);

        const remittance = yield call(claimPaymentService.getRemittanceByIdService, action?.payload?.remittanceId);
        yield put({
            type: GET_REMITTANCE_BY_ID_SUCCESS,
            payload: remittance?.data,
        });

        if (action?.payload?.getParams) {
            const res = yield call(
                claimPaymentService.getClaimPaymentFilteredService,
                action?.payload?.remittanceId,
                action?.payload?.getParams
            );
            yield put({
                type: GET_CLAIM_PAYMENT_FILTERED_SUCCESS,
                payload: res.data,
            });

            // const claimPmt = yield call(claimPaymentService.getClaimPaymentsService, action?.payload?.getParams);
            // yield put({
            //     type: GET_CLAIM_PAYMENTS_SUCCESS,
            //     payload: { claimPayments: claimPmt?.data },
            // });
        }

        if (action?.payload?.reqParams) {
            const res = yield call(
                claimPaymentService.getRemittanceByIdClaimsService,
                action?.payload?.remittanceId,
                action?.payload?.reqParams
            );
            yield put({
                type: GET_REMITTANCE_BY_ID_CLAIMS_SUCCESS,
                payload: res.data,
            });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* appealClaimPmt(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimPaymentService.appealClaimPmtService, action?.payload?.body);

        const claimPmt = yield call(
            claimPaymentService.getClaimPaymentFilteredService,
            action?.payload?.remittanceId,
            action?.payload?.getParams
        );
        yield put({
            type: GET_CLAIM_PAYMENT_FILTERED_SUCCESS,
            payload: claimPmt?.data,
        });

        // const res = yield call(claimPaymentService.getClaimPaymentsService, action?.payload?.getParams);
        // yield put({
        //     type: GET_CLAIM_PAYMENTS_SUCCESS,
        //     payload: { claimPayments: res.data },
        // });

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* payInFullClaim(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimPaymentService.payInFullClaimService, action?.payload?.body);

        const remittance = yield call(claimPaymentService.getRemittanceByIdService, action?.payload?.remittanceId);
        yield put({
            type: GET_REMITTANCE_BY_ID_SUCCESS,
            payload: remittance?.data,
        });

        const claimPmt = yield call(
            claimPaymentService.getClaimPaymentFilteredService,
            action?.payload?.remittanceId,
            action?.payload?.getParams
        );
        yield put({
            type: GET_CLAIM_PAYMENT_FILTERED_SUCCESS,
            payload: claimPmt?.data,
        });

        // const claimPmt = yield call(claimPaymentService.getClaimPaymentsService, action?.payload?.getParams);
        // yield put({
        //     type: GET_CLAIM_PAYMENTS_SUCCESS,
        //     payload: { claimPayments: claimPmt?.data },
        // });

        if (action?.payload?.reqParams) {
            const res = yield call(
                claimPaymentService.getRemittanceByIdClaimsService,
                action?.payload?.remittanceId,
                action?.payload?.reqParams
            );
            yield put({
                type: GET_REMITTANCE_BY_ID_CLAIMS_SUCCESS,
                payload: res.data,
            });
        }

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* payInFullClaimBilling(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimPaymentService.payInFullClaimBillingService, action?.payload?.body);

        const remittance = yield call(claimPaymentService.getRemittanceByIdService, action?.payload?.remittanceId);
        yield put({
            type: GET_REMITTANCE_BY_ID_SUCCESS,
            payload: remittance?.data,
        });

        const claimPmt = yield call(
            claimPaymentService.getClaimPaymentFilteredService,
            action?.payload?.remittanceId,
            action?.payload?.getParams
        );
        yield put({
            type: GET_CLAIM_PAYMENT_FILTERED_SUCCESS,
            payload: claimPmt?.data,
        });

        // const claimPmt = yield call(claimPaymentService.getClaimPaymentsService, action?.payload?.getParams);
        // yield put({
        //     type: GET_CLAIM_PAYMENTS_SUCCESS,
        //     payload: { claimPayments: claimPmt?.data },
        // });

        if (action?.payload?.reqParams) {
            const res = yield call(
                claimPaymentService.getRemittanceByIdClaimsService,
                action?.payload?.remittanceId,
                action?.payload?.reqParams
            );
            yield put({
                type: GET_REMITTANCE_BY_ID_CLAIMS_SUCCESS,
                payload: res.data,
            });
        }

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* removeClaimFromRemittance(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimPaymentService.removeClaimFromRemittanceService, action?.payload?.body);
        const remittance = yield call(claimPaymentService.getRemittanceByIdService, action?.payload?.body?.remittanceId);
        yield put({
            type: GET_REMITTANCE_BY_ID_SUCCESS,
            payload: remittance?.data,
        });

        if (action?.payload?.reqParams) {
            const res = yield call(
                claimPaymentService.getRemittanceByIdClaimsService,
                action?.payload?.body?.remittanceId,
                action?.payload?.reqParams
            );
            yield put({
                type: GET_REMITTANCE_BY_ID_CLAIMS_SUCCESS,
                payload: res.data,
            });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

export const watchClaimPayment = function* watchClaimPaymentSaga() {
    /** Claim Payment */
    yield takeLatest(CREATE_REMITTANCE, createClaimPayments);
    yield takeLatest(EDIT_REMITTANCE, editRemittance);
    yield takeLatest(GET_REMITTANCE, getRemittance);
    yield takeLatest(VERIFY_REMITTANCES, verifyRemittance);
    yield takeLatest(MARK_REVIEWED_REMITTANCE, markReviewedRemittance);
    yield takeLatest(SYNC_TL_CLEARINGHOUSE_ERAS, syncTlClearinghouseEras);
    yield takeLatest(GET_REMITTANCE_BY_ID, getRemittanceById);
    yield takeLatest(GET_REMITTANCE_BY_ID_CLAIMS, getRemittanceByIdClaims);
    yield takeLatest(VOID_REMITTANCE, voidRemittance);
    yield takeLatest(MASS_VOID_REMITTANCE, massVoidRemittance);
    yield takeLatest(DELETE_REMITTANCE, deleteRemittance);
    yield takeLatest(GET_REMITTANCE_TOTAL, getRemittanceTotal);

    yield takeLatest(GET_CLAIM_PAYMENT_FILTERED, getClaimPaymentFiltered);
    yield takeLatest(GET_CLAIM_PAYMENTS, getClaimPayments);
    yield takeLatest(EDIT_CLAIM_PAYMENT_INFO, editClaimPaymentInfo);
    yield takeLatest(APPEAL_CLAIM_PAYMENT, appealClaimPmt);
    yield takeLatest(PAY_IN_FULL_CLAIM, payInFullClaim);
    yield takeLatest(PAY_IN_FULL_CLAIM_BILLING, payInFullClaimBilling);
    yield takeLatest(REMOVE_CLAIM_FROM_REMITTANCE, removeClaimFromRemittance);
    /** End */
};
